import { BaseModel, RecursivePartial, SM } from '@models/base';

export enum VzFileReferenceType {
    Unknown = 'Unknown',
    Task = 'task.files',
    Chat = 'chat.file',
    Event = 'event.file',
    Wiki = 'wiki.file',
}

export const VzFileReferenceName: SM<string> = {
    [VzFileReferenceType.Unknown]: 'Другое',
    [VzFileReferenceType.Chat]: 'Чаты',
    [VzFileReferenceType.Task]: 'Задачи',
    [VzFileReferenceType.Event]: 'Календарь',
    [VzFileReferenceType.Wiki]: 'База знаний',
}

export class VzFileReference extends BaseModel {
    static Type = VzFileReferenceType;
    type?: VzFileReferenceType;
    refId1?: string;
    refId2?: string;

    constructor(json?: RecursivePartial<VzFileReference>) {
        super(json);
        this.parseVzFileReference(json || {});
    }

    parse(json: RecursivePartial<VzFileReference>): VzFileReference {
        super.parse(json);
        this.parseVzFileReference(json);
        return this;
    }

    private parseVzFileReference(json: RecursivePartial<VzFileReference>): void {
        VzFileReference.assignFields<VzFileReference>(this, json, [
            'type',
            'refId1',
            'refId2',
        ]);
    }
}
